import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Input, Row } from "antd";
import React from "react";
import CivilLookupTypeDropdown from "./civil-lookup-type-dropdown";
import LookupTypeDropdown from "./lookup-type-dropdown";

type SearchControlProps = {
  onSearch?: (e) => void;
  dataSet?: unknown;
  fields?: unknown;
  onConditionChange: (e) => void;
  onSearchChange: (e) => void;
  onCivilScreen?: boolean;
  conditionSearch?: string;
  conditionValue?: string;
  isReturn?: boolean;
  onNewSearch?: (e) => void;
  fromPage?: boolean;
  loading?: boolean;
};

const SearchControl = ({ ...props }: SearchControlProps) => {
  const { onSearch, onConditionChange, onSearchChange, onCivilScreen, conditionSearch, conditionValue, isReturn, onNewSearch, fromPage, loading } = props;

  return (
    <Row gutter={[16, 16]}>
      <Col lg={8} md={8} sm={24} xs={24}>
        {!onCivilScreen ? (
          <LookupTypeDropdown value={conditionValue} onChange={onConditionChange} style={{ width: "100%" }} placeholder="Select a condition" disabled={fromPage} />
        ) : (
          <CivilLookupTypeDropdown value={conditionValue} onChange={onConditionChange} style={{ width: "100%" }} placeholder="Select a condition" />
        )}
      </Col>
      <Col lg={8} md={8} sm={12} xs={24}>
        <Input
          onPressEnter={onSearch}
          value={conditionSearch}
          onChange={onSearchChange}
          placeholder={!onCivilScreen ? "Case Number, date of birth, etc." : "Plantiff, Defendant, Case Number"}
          disabled={fromPage}
          autoFocus
        />
      </Col>
      {!isReturn && (
        <Col lg={8} md={8} sm={12} xs={24}>
          <Button block icon={<FontAwesomeIcon icon={["fas", "search"]} />} onClick={onSearch} loading={loading} disabled={isReturn}>
            Lookup
          </Button>
        </Col>
      )}
      {isReturn && (
        <Col lg={8} md={8} sm={12} xs={24}>
          <Button block icon={<FontAwesomeIcon icon={["fas", "plus"]} />} onClick={onNewSearch}>
            New Query
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default SearchControl;
